// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-coordinate-system"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M11.4965 5L1.97021 21.5H11.4965V5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11.4965 6V21M11.4965 11H14.5002M11.4965 14.5H16.5002M11.4965 18H18.5002M11.4965 5L21.0228 21.5H1.97021L11.4965 5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19.25 3L19.7697 4.23028L21 4.75L19.7697 5.26972L19.25 6.5L18.7303 5.26972L17.5 4.75L18.7303 4.23028L19.25 3Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-coordinate-system')
export default class AiCoordinateSystemIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-coordinate-system',
    }
  }
}
